import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import Debug from 'debug';
import { ManageProductsResponse } from '../models/manageProductContent/managedProductsResponse.model';
import {
    ProductCategoriesUpdateRequest,
    ProductCategoriesUpdateRequestModel,
} from '../models/manageProductContent/updateProductCategories.model';
import {
    ProductContentUpdateRequest,
    ProductContentUpdateRequestModel,
} from '../models/manageProductContent/updateProductContent.model';
import { AdminConfigService } from './../admin.config';

const debug = Debug('modeso:dgoods-lib-admin-fe:AdminManageProductContentService');
@Injectable({ providedIn: 'root' })
export class AdminManageProductContentService {
    private readonly server = '';
    private readonly microserviceName = 'products';
    private readonly route = '/manage';
    private readonly updateProductCategoriesRoute = '/updateProductCategories';
    /**
     *
     * @param http
     * @param config
     */
    constructor(
        private http: HttpClient,
        @Inject(AdminConfigService) private config,
    ) {
        this.server = config.apiGateway;
    }

    getAllProducts() {
        const url = `${this.server}${this.microserviceName}${this.route}`;
        debug(url);
        return this.http.get<ManageProductsResponse>(url);
    }

    updateContentByProductLine(content: { payload: ProductContentUpdateRequest }) {
        const url = `${this.server}${this.microserviceName}${this.route}/${content.payload.productLineName}`;
        return this.http.post(
            url,
            new ProductContentUpdateRequestModel(content.payload.locale, content.payload.description),
        );
    }

    updateProductCategories(update: { payload: ProductCategoriesUpdateRequest }) {
        const url = `${this.server}${this.microserviceName}${this.updateProductCategoriesRoute}/${update.payload.productLineName}`;
        return this.http.post(url, new ProductCategoriesUpdateRequestModel(update.payload.categories));
    }
}
